import React from "react";
import DataGrid from "../../../components/app/grid/DataGrid";
import ApplicantRequestsGrid from "./ApplicantRequestsGrid";
import { IRequestType } from "../../../../model/request/RequestType";
import { TRequestPresentationModel } from "../../../../presenter/request/model/RequestPresentationModel";
import { TApplicantReportingPeriodPresentationModel } from "../../../../presenter/applicants/model/ApplicantReportingPeriodPresentationModel";
import { IApplicantReportingPeriod } from "../../../../model/applicant/ApplicantReportingPeriod";
import { Spin } from "antd";

export interface Props {
  requests: TRequestPresentationModel[];
  translate: any;
  reportingPeriods: TApplicantReportingPeriodPresentationModel[];
  onRowExpanded: any;
  requestTypes: IRequestType[];
  createRequest: any;
  updateRequest: any;
  expandedReportingPeriod?: IApplicantReportingPeriod;
  loader?: boolean;
}

export interface State {}

export default class ApplicantReportingPeriodGrid extends React.Component<
  Props,
  State
> {
  constructor(props) {
    super(props);
    this.state = {
      requests: [],
      reportingPeriods: [],
      requestTypes: []
    };
  }

  render() {
    const {
      requests,
      translate,
      reportingPeriods,
      onRowExpanded,
      requestTypes,
      createRequest,
      updateRequest,
      expandedReportingPeriod,
      loader
    } = this.props;
    const applicantReportingPeriodColumns = [
      {
        title: translate("requestTypes_page.reporting_period_name"),
        dataIndex: "reportingPeriodName",
        key: "reportingPeriodName"
      }
    ];

    const expandedRowRender = () => {
      return (
        <Spin spinning={loader}>
          <ApplicantRequestsGrid
            items={requests}
            translate={translate}
            reportingPeriods={reportingPeriods}
            requestTypes={requestTypes}
            updateRequest={updateRequest}
            createRequest={createRequest}
            expandedReportingPeriod={expandedReportingPeriod}
          />
        </Spin>
      );
    };
    let codebooks = [reportingPeriods, requestTypes];
    return (
      <DataGrid
        title={translate("grids.applicant-requests")}
        translate={translate}
        columns={applicantReportingPeriodColumns}
        codebooks={codebooks}
        dataSource={reportingPeriods}
        expandedRowRender={expandedRowRender}
        singleRowExpandEnabled={true}
        onExpand={onRowExpanded}
        allowCreate={false}
        createModalTitle={translate("applicantRequest_page.insert_modal_title")}
        addButtonText={translate("applicantRequest_page.add_button_text")}
      />
    );
  }
}
